module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ruth Gillen, Leon Fleisher, Russell Sherman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Ruth Gillen is a pianist who studied with the duo-pianists Vronsky and Babin, as well as with Konrad Wolff.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1B23M2C/tc-custom/9780253028396.jpg?1718106101329",
      "alt": "This image is the cover for the book Writings and Letters of Konrad Wolff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Writings and Letters of Konrad Wolff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"[Wolff] is a remarkable pianist, an excellent theoretician, a learned teacher, a brilliant thinker and writer.\" —Artur Schnabel")]), _c('p', [_vm._v("\"This collection of [Wolff's] writings and letters should bear ample testimony to a musician who happily combined the artist, the teacher, the musicologist, and the charm and integrity of a human being.\" —Alfred Brendel")]), _c('p', [_vm._v("\"Konrad Wolff writes about music with the verve and enthusiasm of a great teacher who has never lost his sense of music as an adventure. To read him is to enter into a lively dialogue with a superior musical mind and a buoyant spirit.\" —Richard Goode")]), _c('p', [_vm._v("This collection provides elegant and thorough portraits of an important 20th-century performer and lover of music, as well as of his greatest influences.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Indiana University Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0